(function($) {
    let currentRecaptchaToken = '';

    // 1. Intercept any outgoing AJAX requests targeting the newsletter subscription endpoint
    $.ajaxPrefilter(function(options) {
        if (options.url && options.url.indexOf('ghostpress_newsletter_subscribe') !== -1) {
            if (currentRecaptchaToken) {
                if (typeof options.data === 'string') {
                    options.data += '&g-recaptcha-response=' + encodeURIComponent(currentRecaptchaToken);
                } else if (typeof options.data === 'object') {
                    options.data['g-recaptcha-response'] = currentRecaptchaToken;
                }
            }
        }
    });

    // 2. Capture Click Phase: Validate HTML5 BEFORE Google reCAPTCHA triggers
    document.addEventListener('DOMContentLoaded', function () {
        const recaptchaButton = document.querySelector('.newsletter-button.g-recaptcha');

        if (recaptchaButton) {
            // Attach listener directly to the button using the capture phase (true)
            recaptchaButton.addEventListener('click', function (e) {
                const form = this.closest('form');
                if (!form) return;

                // Check native HTML5 validation
                if (!form.checkValidity()) {
                    // Block Google reCAPTCHA from running
                    e.preventDefault();
                    e.stopImmediatePropagation();

                    // Show browser error popup
                    form.reportValidity();
                    return false;
                }
            }, true); // runs BEFORE Google's click listener
        }
    });

    // 3. Google reCAPTCHA callback when user clicks submit
    window.onSubmitNewsletter = function(token) {
        currentRecaptchaToken = token;

        grecaptcha.reset();

        let $form = $('.newsletter-button.g-recaptcha').closest('form');
        if (!$form.length) {
            $form = $('form.newsletter-form');
        }

        // Trigger the existing script's submit handler
        $form.trigger('submit');
    };
})(jQuery);